import React from "react";

const FullScreenLoader = ({ text = "Loading..." }) => {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white z-[9999]">

      {/* Thin multi-color spinner */}
      <div
        className="w-12 h-12 rounded-full border-2 border-transparent animate-spin"
        style={{
          borderTopColor: "#5bc17d",
          borderRightColor: "#2c80ff",
          borderBottomColor: "#ff4e74",
          borderLeftColor: "transparent",
        }}
      ></div>

      <p className="mt-4 text-gray-600 text-sm tracking-wide">{text}</p>
    </div>
  );
};

export default FullScreenLoader;
